<template>
  <DefaultLayout :loading="loading">
    <template #header>
      <div class="headerContainer">
        <h1 class="title">Envio da selfie</h1>
        <span class="subtitle"> Sua foto garante a segurança da sua compra. </span>
      </div>
    </template>
    <template #default>
      <div class="main-container">
        <section class="card-container">
          <div class="card">
            <h1 class="card-title">Dicas para a foto</h1>
            <ul class="card-list">
              <li>Procure um ambiente bem iluminado</li>
              <li>Retire boné, óculos ou qualquer acessório que esteja utilizando</li>
            </ul>
          </div>
        </section>
      </div>
      <div class="button-container">
        <Button theme="ame" class="button" @click="handleClick"> Continuar </Button>
      </div>
    </template>
  </DefaultLayout>
</template>

<script>
import { defineComponent, onMounted, ref } from 'vue';
import { useRouter, useRoute } from 'vue-router/composables';
import DefaultLayout from '@/feature/minified-onboarding/layout/DefaultLayout.vue';
import Button from '@/components/ui/AppButton.vue';
import { useStore } from '@/utils/store';

export default defineComponent({
  name: 'SelfieInstructionsView',
  components: {
    Button,
    DefaultLayout,
  },
  setup() {
    const store = useStore();
    const route = useRoute();
    const router = useRouter();
    const loading = ref(true);

    async function handleClick() {
      await router.replace({
        name: 'onboarding-minified-facetec',
        query: route.query,
      });
    }

    onMounted(async () => {
      const { userId, onboardingToken: token, onboardingId } = route.query;

      loading.value = true;
      await store?.dispatch('auth/setToken', { token });
      await store?.dispatch('minifiedOnboarding/getOnboarding', {
        userId,
        onboardingId,
      });
      loading.value = false;
    });

    return {
      handleClick,
      loading,
    };
  },
});
</script>

<style lang="scss" scoped>
.headerContainer {
  display: flex;
  flex-direction: column;
  gap: 0.75rem;
  .title {
    display: flex;
    gap: 0.25rem;
    align-items: center;
    font-size: 1.5rem;
    line-height: 2rem;
    font-weight: 700;
  }

  .subtitle {
    font-size: 1rem;
    line-height: 1.5rem;
    color: #64748b;
  }
}

.main-container {
  display: flex;
  align-items: center;
  flex-direction: column;
  margin-top: 24px;
  height: 100%;

  .card-container {
    display: flex;
    align-items: center;
    flex-direction: column;
    height: 100%;

    .card {
      display: flex;
      padding: 1rem;
      flex-direction: column;
      gap: 0.75rem;
      border-radius: 0.75rem;
      border: none;
      background-color: #f3f4f6;
      .card-title {
        font-size: 0.875rem;
        line-height: 1.25rem;
        font-weight: 600;
        color: #6b7280;
      }

      .card-list {
        display: flex;
        flex-direction: column;
        gap: 0.5rem;
        margin-left: 1.5rem;
        font-size: 0.875rem;
        line-height: 1.25rem;
        list-style-type: disc;
        color: #6b7280;
      }
    }
  }
}

.button-container {
  display: flex;
  flex-direction: column;
  align-items: center;

  .button {
    display: flex;
    align-items: center;
    background: #ed0059;
    color: #ffffff;
    font-weight: 600;
    border: none;
    justify-content: center;
    border-radius: 24px;
    width: 100%;
    height: 48px;
  }
}
</style>
